import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";

export const InviteeNotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="flex h-full flex-col items-center justify-center">
      <div className="mb-8 flex flex-col gap-2">
        <h1 className="text-3xl font-bold text-gray-900">Oh no! Something went wrong.</h1>
        <p className="text-lg text-gray-600">
          It seems like you've already created an account or the invite is expired.
        </p>
      </div>
      <div className="flex w-full justify-end">
        <Button onClick={() => navigate("/login")} className="w-fit phone:w-full">
          Go to Login
        </Button>
      </div>
    </div>
  );
};
